/* DISTRICT LAB — visor de imágenes con zoom.
   Toca una foto y se abre grande, con pellizco para acercar. Sin dependencias.

   GEMELO de assets/vl-visor.js de VÉLORA: mismo código, con el prefijo de esta
   marca. Son dos tiendas y dos temas distintos, así que no hay forma de
   compartir el archivo. Si se arregla algo aquí, hay que llevarlo allá —y al
   revés—; lo que costó descubrirlo está anotado en los dos TEMA.md.

   Lo usan tres secciones (galería, detalles de "Por qué funciona" y colores
   disponibles) y cada una lo incluye por su cuenta, así que el mismo <script>
   puede acabar varias veces en la página: lo primero que hace es plantarse si
   ya se montó. */
(function () {
  if (window.__dlVisor) return;
  window.__dlVisor = true;

  var MAX = 5; /* tope de acercamiento */
  var DOBLE = 2.5; /* a cuánto salta el doble toque */
  var UMBRAL = 60; /* píxeles de arrastre para pasar de foto */

  var visor, lienzo, img, pie, cuenta, antes, despues;
  var grupo = [];
  var indice = 0;
  var s = 1, x = 0, y = 0; /* escala y desplazamiento actuales */
  var baseW = 0, baseH = 0; /* tamaño de la foto sin acercar */
  var punteros = {}, nPunteros = 0;
  var pinchaDist = 0, pinchaS = 1, pinchaCx = 0, pinchaCy = 0;
  var arrastraX = 0, arrastraY = 0, movido = false;
  var huboPincha = false; /* si el gesto llegó a tener dos dedos */
  var ultimoToque = 0, ultimoToqueX = 0, ultimoToqueY = 0;
  var devolverFoco = null;

  /* ---------- construcción, una sola vez y a demanda ---------- */
  function montar() {
    if (visor) return;
    visor = document.createElement("div");
    visor.className = "dl dl-visor";
    visor.setAttribute("role", "dialog");
    visor.setAttribute("aria-modal", "true");
    visor.setAttribute("aria-label", "Imagen ampliada");
    visor.hidden = true;
    visor.innerHTML =
      '<button type="button" class="dl-visor-cerrar" aria-label="Cerrar">&times;</button>' +
      '<button type="button" class="dl-visor-nav dl-visor-antes" aria-label="Foto anterior">&lsaquo;</button>' +
      '<button type="button" class="dl-visor-nav dl-visor-despues" aria-label="Foto siguiente">&rsaquo;</button>' +
      '<div class="dl-visor-lienzo"><img alt=""></div>' +
      '<div class="dl-visor-pie"><span class="dl-visor-cuenta"></span><span class="dl-visor-texto"></span></div>';
    document.body.appendChild(visor);

    lienzo = visor.querySelector(".dl-visor-lienzo");
    img = visor.querySelector("img");
    pie = visor.querySelector(".dl-visor-texto");
    cuenta = visor.querySelector(".dl-visor-cuenta");
    antes = visor.querySelector(".dl-visor-antes");
    despues = visor.querySelector(".dl-visor-despues");

    visor.querySelector(".dl-visor-cerrar").addEventListener("click", cerrar);
    antes.addEventListener("click", function () { ir(-1); });
    despues.addEventListener("click", function () { ir(1); });

    /* Tocar el fondo cierra. No cuando está acercada —ese toque suele ser el
       final de un arrastre— ni cuando el dedo se movió, porque un deslizamiento
       para pasar de foto también acaba en un `click` sobre el fondo. */
    lienzo.addEventListener("click", function (ev) {
      if (ev.target !== img && s === 1 && !movido) cerrar();
    });

    img.addEventListener("load", encuadrar);
    lienzo.addEventListener("wheel", rueda, { passive: false });
    lienzo.addEventListener("pointerdown", abajo);
    lienzo.addEventListener("pointermove", mueve);
    lienzo.addEventListener("pointerup", arriba);
    lienzo.addEventListener("pointercancel", arriba);
    lienzo.addEventListener("dblclick", function (ev) {
      ev.preventDefault();
      acercarEn(s > 1 ? 1 : DOBLE, ev.clientX, ev.clientY);
    });

    document.addEventListener("keydown", function (ev) {
      if (visor.hidden) return;
      if (ev.key === "Escape") cerrar();
      else if (ev.key === "ArrowLeft") ir(-1);
      else if (ev.key === "ArrowRight") ir(1);
      else if (ev.key === "+" || ev.key === "=") acercarEn(s * 1.4, 0, 0, true);
      else if (ev.key === "-") acercarEn(s / 1.4, 0, 0, true);
    });

    window.addEventListener("resize", function () {
      if (!visor.hidden) encuadrar();
    });
  }

  /* ---------- transformación ---------- */
  function aplicar() {
    img.style.transform = "translate(" + x + "px," + y + "px) scale(" + s + ")";
    img.style.cursor = s > 1 ? "grab" : "zoom-in";
    visor.setAttribute("data-acercada", s > 1 ? "si" : "no");
  }

  /* El desplazamiento no puede sacar la foto de la pantalla: como mucho, sus
     bordes llegan a los del lienzo. */
  function limitar() {
    var cw = lienzo.clientWidth, ch = lienzo.clientHeight;
    var mx = Math.max(0, (baseW * s - cw) / 2);
    var my = Math.max(0, (baseH * s - ch) / 2);
    x = Math.min(mx, Math.max(-mx, x));
    y = Math.min(my, Math.max(-my, y));
  }

  function encuadrar() {
    s = 1; x = 0; y = 0;
    img.style.transform = "";
    var r = img.getBoundingClientRect();
    baseW = r.width; baseH = r.height;
    aplicar();
  }

  /* Acerca dejando quieto el punto que hay bajo el dedo (o el cursor). */
  function acercarEn(nueva, cx, cy, centrado) {
    nueva = Math.min(MAX, Math.max(1, nueva));
    var r = lienzo.getBoundingClientRect();
    var ox = r.left + r.width / 2, oy = r.top + r.height / 2;
    if (centrado) { cx = ox; cy = oy; }
    x = cx - ox - (cx - ox - x) * (nueva / s);
    y = cy - oy - (cy - oy - y) * (nueva / s);
    s = nueva;
    if (s === 1) { x = 0; y = 0; }
    limitar();
    aplicar();
  }

  function rueda(ev) {
    ev.preventDefault();
    acercarEn(s * (ev.deltaY < 0 ? 1.18 : 1 / 1.18), ev.clientX, ev.clientY);
  }

  /* ---------- dedos ---------- */
  function dedos() {
    var out = [];
    for (var k in punteros) out.push(punteros[k]);
    return out;
  }

  function abajo(ev) {
    if (!punteros[ev.pointerId]) nPunteros++;
    punteros[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
    try { lienzo.setPointerCapture(ev.pointerId); } catch (e) {}

    if (nPunteros === 1) {
      /* Empieza un gesto nuevo: solo aquí se reinician las banderas. */
      movido = false;
      huboPincha = false;
      arrastraX = ev.clientX;
      arrastraY = ev.clientY;
    } else if (nPunteros === 2) {
      huboPincha = true;
      var d = dedos();
      pinchaDist = Math.hypot(d[0].x - d[1].x, d[0].y - d[1].y);
      pinchaS = s;
      pinchaCx = (d[0].x + d[1].x) / 2;
      pinchaCy = (d[0].y + d[1].y) / 2;
    }
  }

  function mueve(ev) {
    if (!punteros[ev.pointerId]) return;
    var prev = punteros[ev.pointerId];
    punteros[ev.pointerId] = { x: ev.clientX, y: ev.clientY };

    if (nPunteros >= 2) {
      var d = dedos();
      var dist = Math.hypot(d[0].x - d[1].x, d[0].y - d[1].y);
      if (pinchaDist > 0) acercarEn(pinchaS * (dist / pinchaDist), pinchaCx, pinchaCy);
      movido = true;
      return;
    }

    if (Math.abs(ev.clientX - arrastraX) > 6 || Math.abs(ev.clientY - arrastraY) > 6) movido = true;
    if (s > 1) {
      x += ev.clientX - prev.x;
      y += ev.clientY - prev.y;
      limitar();
      aplicar();
    }
  }

  function arriba(ev) {
    var salida = punteros[ev.pointerId];
    if (salida) {
      delete punteros[ev.pointerId];
      nPunteros = Math.max(0, nPunteros - 1);
    }
    if (nPunteros < 2) pinchaDist = 0;
    if (nPunteros !== 0 || !salida) return;

    /* Un gesto que llegó a tener dos dedos no es ni arrastre ni toque: al
       levantarlos, `arrastraX` es de otro dedo y `movido` viene del pellizco.
       Interpretarlo pasaba de foto sola al terminar de acercar. */
    if (huboPincha) return;

    if (movido) {
      /* Sin acercar, un arrastre lateral pasa de foto. Acercada, ese mismo
         gesto es mover la foto y no debe cambiar nada. */
      if (s === 1) {
        var dx = salida.x - arrastraX, dy = salida.y - arrastraY;
        if (Math.abs(dx) > UMBRAL && Math.abs(dx) > Math.abs(dy)) ir(dx < 0 ? 1 : -1);
      }
      return;
    }

    /* Doble toque, medido al LEVANTAR y no al apoyar: en móvil no llega un
       dblclick fiable, y hacerlo al apoyar confundía el primer dedo de un
       pellizco con el segundo toque, así que el zoom se reseteaba solo. */
    if (ev.pointerType !== "touch") return;
    var ahora = Date.now();
    var cerca = Math.hypot(salida.x - ultimoToqueX, salida.y - ultimoToqueY) < 40;
    if (ahora - ultimoToque < 300 && cerca) {
      acercarEn(s > 1 ? 1 : DOBLE, salida.x, salida.y);
      ultimoToque = 0;
      return;
    }
    ultimoToque = ahora;
    ultimoToqueX = salida.x;
    ultimoToqueY = salida.y;
  }

  /* ---------- navegación ---------- */
  function pintar() {
    var el = grupo[indice];
    img.src = el.getAttribute("data-dl-grande") || el.currentSrc || el.src;
    img.alt = el.getAttribute("alt") || "";
    pie.textContent = el.getAttribute("alt") || "";
    cuenta.textContent = grupo.length > 1 ? indice + 1 + " / " + grupo.length : "";
    antes.hidden = grupo.length < 2;
    despues.hidden = grupo.length < 2;
    encuadrar();
  }

  function ir(paso) {
    if (grupo.length < 2) return;
    indice = (indice + paso + grupo.length) % grupo.length;
    pintar();
  }

  function abrir(el) {
    montar();
    var g = el.getAttribute("data-dl-grupo");
    grupo = g
      ? [].slice.call(document.querySelectorAll('[data-dl-zoom][data-dl-grupo="' + g + '"]'))
      : [el];
    indice = Math.max(0, grupo.indexOf(el));
    devolverFoco = document.activeElement;
    visor.hidden = false;
    document.documentElement.style.overflow = "hidden";
    pintar();
    visor.querySelector(".dl-visor-cerrar").focus();
  }

  function cerrar() {
    visor.hidden = true;
    document.documentElement.style.overflow = "";
    img.removeAttribute("src");
    if (devolverFoco && devolverFoco.focus) devolverFoco.focus();
  }

  /* ---------- enganche ----------
     Delegado en el documento: las fotos de color y las de detalle pueden
     aparecer después (acordeón cerrado, carril que carga tarde) y así no hay
     que volver a enganchar nada cuando cambian. */
  document.addEventListener("click", function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest("[data-dl-zoom]") : null;
    if (!el) return;
    if (visor && visor.contains(el)) return;
    ev.preventDefault();
    abrir(el);
  });
})();
